import { XCircleIcon } from "lucide-react";
import styles from "./CitrixNotification.module.scss";

interface CitrixNotificationProps {
	isOpen: boolean;
	onClose: () => void;
}

export const CitrixNotification = ({
	isOpen,
	onClose,
}: CitrixNotificationProps) => {
	return (
		<>
			{isOpen && (
				<div className={styles.citrixNotification}>
					<p className={styles.citrixNotification__title}>
						Spot a data anomaly? Let us know via Feedback button below and we'll
						fix it&nbsp;&nbsp;|&nbsp;&nbsp; To view Citrix artefacts please
						access Einstein via Citrix
					</p>
					<button
						type="button"
						className={styles.citrixNotification__button}
						onClick={onClose}
					>
						<XCircleIcon width={21} height={21} />
					</button>
				</div>
			)}
		</>
	);
};
